// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2k5tZ","footer":"ModalInfo_footer__2WZYI"};